import moment from 'moment';

/**
 * Get current UNIX timestamp
 * @returns {number} unix timestamp(millisecond)
 */
const getCurrentUnixTimestamp = () => {
  return moment().valueOf();
};

/**
 *
 * @param {number} timestamp unix timestamp(millisecond)
 * @param {*} format MMM D
 * @return {String}
 */
const formatUnixTimestamp = (timestamp, format) => {
  return moment(timestamp).format(format);
};

export default {
  getCurrentUnixTimestamp,
  formatUnixTimestamp,
};
